export const SNACKBAR_SUCCESS = 'snackbar.success';
export const SNACKBAR_FAILURE = 'snackbar.failure';
